<script lang="ts" setup>
  import { useConfirmation, useHttpClient, useRoute, useShared, useTranslator } from '@othercommerce/foundation';
  import type { SharedOrder } from '@storefront/resources';
  import { clearCartEvent, useGoogleTagManager } from '@storefront/storefront';

  interface Props {
    isCartEmpty: boolean;
    cart: SharedOrder;
  }

  const props = defineProps<Props>();
  const route = useRoute();
  const confirm = useConfirmation();
  const shared = useShared();
  const http = useHttpClient();
  const translator = useTranslator();
  const gtm = useGoogleTagManager();

  function actionEmpty() {
    confirm({
      title: translator.trans('SHOP.CART.HEADER.CLEAR_CART'),
      description: translator.trans('SHOP.CART.MESSAGE.CLEAR_CART'),
      yes: translator.trans('SHOP.COMMON.ACTION.CLEAR'),
      no: translator.trans('SHOP.COMMON.ACTION.CANCEL'),
      callback: () => {
        gtm.push(clearCartEvent(props.cart, shared.value.activeCurrencyCode));
        http.delete(route('web.cart.destroy'));
      },
    }).catch(() => void (0));
  }
</script>
<template>
  <SfButton :disabled="isCartEmpty" danger small transparent @click="actionEmpty">
    <template #before>
      <SfIconClose aria-hidden="true" />
    </template>
    <template #default>
      {{ $t('SHOP.CART.ACTION.CLEAR_CART') }}
    </template>
  </SfButton>
</template>
